import React from "react";
import {IProduct} from 'data/interfaces/products';
import Conclusion from '../../../commons/conclusionCard/components/conclusion';
import DetailRow
  from 'gui/pages/mainRouter/pages/ad/components/commons/conclusionCard/components/conclusion/components/priceRow';

export interface IPreSaleConclusionProps {
  product?: IProduct;
}

const PurchaseDetails = (props: IPreSaleConclusionProps) => (
  <Conclusion
    originalPrice={props.product.voucherDetails.voucherBalance}
    salePrice={props.product.saleDetails.askingPrice}
    currency={props.product.saleDetails.currency}
    originalPriceComponent={<DetailRow
      label="ערך השובר"
      price={props.product.voucherDetails.voucherBalance}
      currency={props.product.voucherDetails.currency}
      hideWhenNoPrice
    />}
    savingsPriceLabel="הרווח שלך"
  />
);

PurchaseDetails.defaultProps = {
  product: {},
};

export default React.memo(PurchaseDetails);
